import { render, staticRenderFns } from "./Text2Speech.vue?vue&type=template&id=b8e7f766"
import script from "./Text2Speech.vue?vue&type=script&lang=ts&setup=true"
export * from "./Text2Speech.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Text2Speech.vue?vue&type=style&index=0&id=b8e7f766&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports